import {useEffect} from "react";
import {loadGoogleTagScript} from "@/utils/analytics";

/**
 * Load the Google tag script for Google Analytics.
 */
export const useGoogleAnalytics = () => {
  useEffect(() => {
    try {
      // The script must stay in the DOM for the rest of the session — do not
      // remove it on unmount. Removing it during StrictMode double-mount or
      // layout remounts could kill in-flight GA requests.
      loadGoogleTagScript();
    } catch (error) {
      console.error("Error in gtag.js initialization:", error);
    }
  }, []);
};
